import React from "react";

export interface EventArgs {
  category?: string;
  action?: string;
  label?: string;
}

interface GATrackingProps {
  gaTrack?: EventArgs;
}

const withGATracking = <T extends {}>(
  WrappedComponent: React.ComponentType<T>,
): React.FC<T & GATrackingProps> => ({ gaTrack, ...props }) => {
  return (
    <WrappedComponent
      data-gatrack-category={gaTrack?.category}
      data-gatrack-action={gaTrack?.action}
      data-gatrack-label={gaTrack?.label}
      {...(props as T)}
    />
  );
};

export default withGATracking;
